import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import styles from '../../styles/body.module.scss';
import btnStyles from '../../styles/buttons.module.scss'
const ErrorPopUp = ({ open, onClose, message }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          padding: 2,
          textAlign: 'center',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        },
      }}
    >
      <DialogTitle className={styles.warningFontColor} sx={{ fontWeight: 'bold', fontSize: '1.25rem' }}>
        Unstable Internet connection
      </DialogTitle>
      <DialogContent>
        <Typography className={styles.fontFamily} variant="body1"  sx={{ fontWeight: 'bold', marginY: 2 }}>
          If you have just tried to submit a report, this will not have been recorded. Please try again.
        </Typography>
            <Typography className={styles.fontFamily} variant="body1"  sx={{ marginY: 2 }}>
         After you close this message, please check your connection to the Internet before refreshing this page.
        </Typography>
        <Typography className={styles.fontFamily}  variant="body1"  sx={{ marginY: 2 }}>
          For further assistance, if required, please contact: induct@dandara.com
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button  className={btnStyles.closePopupBtn}  size="small" variant="contained" onClick={onClose} >
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorPopUp;
